import React, { MutableRefObject } from 'react'
import styles from '~/styles/atoms/row/row.module.scss'

import { ChildProps } from '~/common/define/props'
import { addClass } from '~/common/utils/html'
import { useColor } from '~/hooks/server/color'
import { ColorWeight, lightenColor } from '~/common/define/color'

interface Props extends ChildProps {
  clickable?: boolean
  selected?: boolean
  disable?: boolean
  onMouseEnter?(): void
  onMouseLeave?(): void
  rowRef?: MutableRefObject<any>
  onClick?(e: React.MouseEvent<HTMLElement>): void
}

const Row = ({children, clickable = false, selected = false, disable = false, onMouseEnter = null, onMouseLeave = null, rowRef = null, onClick = null}: Props) => {
  const color = useColor()

  return (
    <>
      <li
        className={styles.row + addClass(styles.row__disable, disable)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        ref={rowRef}
        onClick={onClick}
      >
        {children}
      </li>
      <style jsx>{`
        li:hover {
          background: ${clickable ? lightenColor(color, ColorWeight.FEATHER) : ''};
        }
        li {
          background: ${selected ? lightenColor(color, ColorWeight.LIGHT) : ''};
        }
      `}</style>
    </>
  )
}

export default Row